import React from 'react'

import cs from 'classnames'
import PropTypes from 'prop-types'

import * as process from 'process'

const BUILD_INFO = `Server ${process.env.SERVER_ENVIRONMENT} build: ${process.env.VERSION}`
const COPYRIGHT_INFO = `Inter IKEA Systems B.V. 1999 - ${new Date().getFullYear()}`

const styles = {
  logo: {
    width: 55
  },
  root: {
    gridRowStart: 2,
    gridRowEnd: 3
  }
}

const FooterLogo = () => (
  <svg viewBox="0 0 90 36" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="IKEA logo"><path d="M0 0V36H90V0H0Z" fill="#0058A3"></path><path d="M1.74374 18.3375C1.74374 27.0562 19.8562 34.3125 44.9437 34.3125C70.0312 34.3125 88.1437 27.0562 88.1437 18.3375C88.1437 9.61874 70.0875 2.36249 45 2.36249C19.9125 2.36249 1.74374 9.61874 1.74374 18.3375Z" fill="#FFDB00"></path><path d="M68.175 24.5813H61.4812C61.7625 24.2438 61.9875 23.85 62.1 23.4563L66.0937 12.5437V12.4875C66.2625 12.15 66.3187 11.7563 66.3187 11.3625H77.625C77.5687 11.7 77.625 11.9812 77.7937 12.2625C77.7937 12.3187 77.85 12.375 77.85 12.4875C78.1875 13.275 81.7875 22.5562 82.0687 23.4C82.1812 23.7937 82.4062 24.1875 82.6875 24.525H74.25C74.25 24.1312 74.1937 23.7375 73.9687 23.4C73.9687 23.4 73.8562 23.0625 73.6312 22.6687L73.575 22.5H68.6812L68.625 22.725C68.625 22.725 68.4562 23.1188 68.3437 23.4563L68.2875 23.5688C68.2312 23.85 68.175 24.2438 68.175 24.5813ZM71.1 15.8063C71.0437 16.0875 70.9875 16.3688 70.875 16.65C70.875 16.7063 70.7062 17.1 70.5375 17.6625C70.3125 18.225 70.0875 18.9563 69.8062 19.7438H72.6187L71.4375 16.7063C71.2687 16.3688 71.1562 16.0875 71.1 15.8063ZM30.4312 24.5813H22.3312C22.5 24.2438 22.5562 23.85 22.5 23.4563V12.5437C22.5562 12.15 22.4437 11.7562 22.3312 11.4187H30.4312C30.2625 11.7562 30.2062 12.15 30.2625 12.5437V17.325C30.2625 17.325 32.85 14.0062 33.4687 13.2188C33.6937 12.9375 34.4812 11.8687 34.4812 11.4187H42.9187C42.2437 11.925 41.6812 12.4875 41.175 13.1062C40.725 13.6687 38.0812 16.8187 38.0812 16.8187C38.0812 16.8187 41.9625 22.6125 42.4687 23.4563C42.75 23.85 43.0875 24.2438 43.425 24.5813H33.6375C33.525 23.9625 33.2437 23.3437 32.85 22.8375C32.4562 22.275 30.4312 19.2375 30.2062 18.9V23.5125C30.2062 23.7937 30.2625 24.1875 30.4312 24.5813ZM60.4687 24.5813H44.775C44.9437 24.2438 45 23.85 44.9437 23.4563V12.5437C45 12.15 44.8875 11.7562 44.775 11.4187H60.4125V15.075C60.075 14.9062 59.6812 14.85 59.2875 14.9062H52.7062V16.65H59.0625V19.4625H52.7062V21.2063H59.2875C59.6812 21.2625 60.075 21.15 60.4125 21.0375L60.4687 24.5813ZM18.45 24.5813H9.67499C9.84374 24.2438 9.89999 23.85 9.84374 23.4563V12.5437C9.89999 12.15 9.78749 11.7562 9.67499 11.4187H18.5062C18.3375 11.7562 18.2812 12.15 18.3375 12.5437V23.4563C18.225 23.7938 18.3375 24.1875 18.45 24.5813ZM81.1687 14.2312C80.6625 14.2312 80.2125 14.0062 79.875 13.6687C79.5375 13.3312 79.3687 12.8813 79.425 12.4313C79.425 12.375 79.425 12.375 79.425 12.3187C79.425 11.4187 80.2125 10.6875 81.1125 10.6875H81.1687H81.225C82.1812 10.6875 82.9125 11.475 82.9125 12.4313V12.5437C82.9125 12.9937 82.6875 13.4437 82.4062 13.725C82.0687 14.0062 81.6187 14.2312 81.1687 14.2312ZM81.0562 11.025C80.7187 11.025 80.3812 11.1937 80.1 11.475C79.875 11.7562 79.7062 12.0938 79.7625 12.4313V12.5437C79.7625 13.275 80.3812 13.8938 81.1687 13.8938H81.225C81.6187 13.8938 81.9562 13.725 82.2375 13.4437C82.5187 13.1625 82.6312 12.825 82.6312 12.4313V12.375C82.6312 11.6438 82.0125 11.025 81.225 11.025H81.0562ZM80.8312 13.4437H80.4937V11.3625H81.2812C81.675 11.3625 81.9562 11.6437 81.9562 12.0375C81.9562 12.3187 81.7875 12.5438 81.5625 12.6562L82.0125 13.4437H81.675L81.2812 12.7125H80.8312V13.4437ZM80.8312 11.7V12.4313H81.2812C81.45 12.4313 81.6187 12.2625 81.6187 12.0938C81.6187 11.8687 81.45 11.7 81.2812 11.7H80.8312Z" fill="#0058A3"></path></svg>
)

const Footer = ({
  build = BUILD_INFO,
  copyright = COPYRIGHT_INFO,
  noXPadding = false
}) => (
  <footer
    data-testid='layout-footer'
    style={styles.root}
    className={cs(
      'flex',
      'justify-between',
      'bg-gray-lighter',
      'c-black-40',
      'width-100',
      'mnx2',
      'f7',
      'py2',
      { px2: !noXPadding }
    )}
  >
    <div
      className={cs(
        'flex',
        'items-center'
      )}
    >
      <div style={styles.logo}>
        <FooterLogo />
      </div>
      <span className='ml1'>
        {copyright}
      </span>
      <a href='/review-privacy-statement' style={{
        paddingLeft: '10px'
      }}>Privacy Statement</a>
    </div>
    <div className={cs(
      'flex',
      'justify-end',
      'items-center'
    )}>
      <span>
        {build}
      </span>
      <a
        href='/changelog/CHANGELOG.html'
        target='_blank'
        className='ml2'
      >
        Changelog
      </a>
    </div>
  </footer>
)

Footer.propTypes = {
  logo: PropTypes.string
}

export default Footer
